import { createContext, useContext } from 'react';

interface CmsPageState {
  pageSlug: string;
  spaceId: string | null;
}

const CmsPageContext = createContext<CmsPageState>({ pageSlug: '', spaceId: null });

export function useCmsPage(): CmsPageState {
  return useContext(CmsPageContext);
}

export { CmsPageContext };
